export const TEMPLATE_DESIGNER_PAGE = 'reporting-template-designer';
export const EXPORT_NATIVE_ELEMENTS_READING_INCREMENT = 10;
export const EXPORT_HTML2CANVAS_JSPDF_PROCESS_INCREMENT = 60;
export const EXPORT_PDF_DOWNLOAD_COMPLETION_INCREMENT = 30;
export const EXPORT_PDF_SCALE_FACTOR = 2;

export enum NestedItemName {
  ParticipantBio = 'participantBio',
  ActivityHistory = 'activityHistory',
  PeerOwnership = 'peerOwnership'
}

export enum RestrictedDragSectionName {
  ActivityAttributes = 'activityAttributes',
  ParticipantsInfo = 'participantsInfo'
}
